
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/page/[cursor]",
      function () {
        return require("private-next-pages/news/page/[cursor].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/page/[cursor]"])
      });
    }
  